import * as ActionTypes from '../ToggleGroup';

export function toggleGroup(data, section) {
    return {type: ActionTypes.TOGGLE_GROUP, data, section};
}

export function expandGroup(data, section) {
    return {type: ActionTypes.EXPAND_GROUP, data, section};
}



// WEBPACK FOOTER //
// ./js/actions/creators/ToggleGroup.js